import { SbsPlayerGlobal } from '../../../common';
import { importScript } from '../../../utils';
import { loadCookie } from '../../../utils/cookie';
import SbsPlayerLogger from '../../../utils/logger';

class SbsAdServer {
  constructor() {
    this.position = '';
    this.uuid = '';
    this.tid = '';
    this.url = '';
    this._data = {};
    this._event = {
      initialized: () => {
        console.log(`initialized.`);
      },
      succeeded: () => {
        console.log(`succeeded.`);
      },
      waiting: () => {
        console.log(`waiting.`);
      },
      failed: () => {
        console.log(`failed.`);
      },
      passed: () => {
        console.log(`passed.`);
      },
      errored: () => {
        console.log(`errored.`);
      },
    };
  }

  get data() {
    return this._data;
  }

  set data(data) {
    return (this._data = data);
  }

  get event() {
    return this._event;
  }

  set event(event) {
    return (this._event = event);
  }

  initialize(position) {
    try {
      this.position = position;

      // 보안: SBS 광고 시 네트워크 광고 컨트롤러 제거
      this.hideNetworkAdControls();
      this.showAdControls();

      // 골프 프리롤 2개 시퀀스: 첫 번째는 link, 두 번째는 link2 사용
      const positionKey = this.position === 'live_midroll' ? 'midroll' : this.position;
      const adData = this._data[positionKey];
      let url;
      
      if (this.position === 'preroll' && adData.link2) {
        // 프리롤이고 link2가 있는 경우 (골프), 시퀀스 인덱스에 따라 선택
        const currentSequenceIndex = SbsPlayerGlobal.view.querySelector('sbs-player-container')?.ads?._i || 0;
        url = currentSequenceIndex === 0 ? adData.link : adData.link2;
        console.log(`#### SBS 골프 프리롤 시퀀스 ${currentSequenceIndex}: ${currentSequenceIndex === 0 ? 'link' : 'link2'} 사용`);
      } else {
        url = adData.link;
      }
      if (url) {
        this.url = new URL(url);
        this.url.protocol = window.location.protocol;

        let uuid = this.uuid;
        let tid = this.tid;
        let cmdata = this._data.cmparam || this._data.cmdata;
        let params = new URLSearchParams(cmdata);
        params.set('x.tid', tid);
        params.set('x.playertype', 'HTML5');
        params.set('d.ifa', uuid);
        params.set('d.model', 'ETC');
        params.set(
          'u.gender',
          loadCookie('SBS_SeX') === ''
            ? 'O'
            : loadCookie('SBS_SeX') === '0'
            ? 'F'
            : 'M'
        );
        params.set('u.g.region', '98');
        params.set('u.x.job', 'ETC');
        params.set(
          'u.x.age',
          loadCookie('SBS_aGe') === '' ? '-1' : loadCookie('SBS_aGe')
        );
        params.set('d.lmt', '0');
        params.set('i.v.startdelay', position === 'midroll' ? '-1' : '0');
        this.url = this.url.href + '?' + params.toString();
        this._event.initialized();
      } else {
        this._event.passed();
      }
    } catch (error) {
      console.log(error);
      this._event.errored();
    }
  }

  // 네트워크 광고 컨트롤러 숨기기 함수
  hideNetworkAdControls() {
    try {
      const networkControls = SbsPlayerGlobal.view.querySelector(
        'sbs-player-ad-newwork-ad-controls'
      );
      if (networkControls) {
        networkControls.visible = false;
        console.log('#### SBS - Network ad controls hidden for SBS ad');
      }
    } catch (error) {
      console.error('#### SBS - Error hiding network ad controls:', error);
    }
  }

  showAdControls() {
    try {
      const adControls = SbsPlayerGlobal.view.querySelector(
        'sbs-player-ad-controls'
      );
      if (adControls) {
        adControls.style.display = 'block';
      }
    } catch (error) {}
  }

  requestAd() {
    try {
      let self = this;
      console.log(this.position, this.url);
      fetch(this.url)
        .then((response) => {
          if (response.status === 200) {
            return response.text();
          } else {
            self._event.failed(response.status);
          }
        })
        .then((responseText) => {
          let parser = new DOMParser();
          let xmlDoc = parser.parseFromString(
            responseText.replace(/\r/g, '').replace(/\n/g, ''),
            'text/xml'
          );

          if (typeof VASTParser === 'undefined') {
            importScript(SbsPlayerGlobal.url.lib.vast_parser, () => {
              let campaign = VASTParser.parseFromXML(xmlDoc);
              self._event.succeeded(campaign);
            });
          } else {
            let campaign = VASTParser.parseFromXML(xmlDoc);
            self._event.succeeded(campaign);
          }
        })
        .catch(() => {
          this._event.errored();
        });
    } catch (error) {
      console.log(error);
      this._event.errored(error);
    }
  }
}

export default SbsAdServer;
